var templateObject = Object.freeze(["\n    query UserConfig {\n      userConfig {\n        sources {\n          name\n          platformAdapterName\n        }\n      }\n    }\n  "]);
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('query-loader',{attrs:{"query":function (gql) { return gql(templateObject); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var data = ref.data;
return [_vm._t("default",null,{"sources":data.userConfig.sources})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }